
// Top Btn
function GoTop() {
	TweenMax.to($('body, html'), 0.5, {scrollTop:0, ease:"Cubic.easeOut"});
}

// gnb_menu
$(function(){
	$('.gnb_btn').click(function() {
		$('.gnb').addClass('on');
	});
	$('.gnb .close').click(function() {
		$(this).parent().removeClass('on');
	});


});



					  
//
  
$(function() {
	/** POP UP **/
	$('.popup .pop_close, .btn_prePop_close').click(function() {
		$(this).closest('.popup').fadeOut().removeClass('on');
		$('.popup_mask').fadeOut();

		// if (typeof top.workSwiper != 'undefined') {
		// 	top.workSwiper.destroy();
		// 	$(this).closest('.popup').find('.swiper-wrapper').attr('style', '');
		// 	top.workSwiper = undefined;
		// }
		// return false;
	});
	$('.popup_mask').click(function() {
		$('.popup').fadeOut().removeClass('on');
		$('.popup_mask').fadeOut();

		// if (typeof top.workSwiper != 'undefined') {
		// 	top.workSwiper.destroy();
		// 	$('.popup').find('.swiper-wrapper').attr('style', '');
		// 	top.workSwiper = undefined;
		// }

	});

});
/** POP UP **/
function pop_close(obj){
	$(obj).fadeOut().removeClass('on');
	$('.popup_mask').fadeOut();
}

function pop_open(obj){
	var popLeft = (($(window).width() - $(obj).outerWidth()) / 2);
	var popTop = (($(window).height() - $(obj).outerHeight()) / 2 );
	if(popLeft < 0) popLeft = 0;
	if(popTop < 0) popTop = 0;
	$('.popup_mask').fadeIn();
	$(obj).css({"left":popLeft, "top":popTop}).fadeIn().addClass('on');

}

$(document).ready(function(){

  	/* 임시 popup */
  	// $('.btn_prePop').click(function(){
  	// 	$('.prePop, .prePop_wrap').fadeIn();
  	// });
  	// $('.btn_prePop02').click(function(){
  	// 	$('.prePop02, .prePop_wrap').fadeIn();
  	// });
  	// $('.btn_prePop03').click(function(){
  	// 	$('.prePop03, .prePop_wrap').fadeIn();
  	// });
  	$('.btn_prePop_close').click(function(){
  		$('.prePop02').fadeOut();
  	});
});
// $(document).ready(function(){
//
//   $('.pay_ico').on("click",function(){
//     $(this).find('on');
//   });
//
// });



// WEBPACK FOOTER //
// ./src/assets/js/commons.js